import React from 'react';
import Dialog from "Components/Core/Dialog";

export default function DialogYesNo(props) {

    const x = props.x;

	x.wad.init(props.id);

	// Destruktiv-Modus (rotes "Ja" fuer Loeschen-Aktionen, Chat vom 2026-08-12).
	// Von x.wau.yesNo(question, cb, destructive) ueber setDanger gesteuert.
	const [danger, setDanger] = React.useState(false);
	React.useEffect(() => {
		x.wad[props.id].setDanger = setDanger;
	}, [x, props.id]);

	function handleClose(event, result) {
		event.preventDefault();
		if (typeof result === 'undefined') {
			result = 0;
		}
		x.wad['yesno'].hide(result);
	}

	return (

		<Dialog id={props.id} x={x}   title={props.title} classes={'dialog-yesno' + (danger ? ' dialog-yesno-danger' : '')} closeIcon="0" modal={true}>
			<div className='div-button'>
				<button className="btn " type="button" onClick={(e) => handleClose(e, 1)} >Ja</button>
				<button className="btn " type="button" onClick={(e) => handleClose(e, 0)} >Nein</button>
			</div>
		</Dialog>

	)
};
